<script setup lang="ts">
import { DropdownMenuContent, DropdownMenuPortal } from 'reka-ui';

withDefaults(
    defineProps<{
        side?: 'top' | 'right' | 'bottom' | 'left';
        sideOffset?: number;
        align?: 'start' | 'center' | 'end';
    }>(),
    {
        side: 'bottom',
        sideOffset: 5,
        align: 'end',
    },
);

// Lets a caller decide where focus goes when the menu closes (by default it returns to the trigger).
defineEmits<{
    closeAutoFocus: [event: Event];
}>();
</script>

<template>
    <DropdownMenuPortal>
        <DropdownMenuContent
            :side="side"
            :side-offset="sideOffset"
            :align="align"
            class="shadow-muval-3 data-[state=closed]:animate-dropdownOut data-[state=open]:animate-dropdownIn z-100 min-w-32 overflow-y-auto rounded-lg border bg-white p-1 outline-hidden"
            @close-auto-focus="$emit('closeAutoFocus', $event)"
        >
            <slot />
        </DropdownMenuContent>
    </DropdownMenuPortal>
</template>
